module.exports = __webpack_public_path__ + "files/baa8d5a222f536918842ca30f49d68aa.png";